if (!customElements.get('ui-swatches')) {
  class UISwatches extends HTMLElement {
    constructor() {
      super();
    }

    get value() {
      /** @type {HTMLInputElement} */
      // @ts-ignore
      const radio = this.querySelector('input:checked');
      return JSON.parse(radio.value);
    }

    connectedCallback() {
      this.querySelectorAll('input').forEach(input => {
        input.addEventListener('change', this.onChange.bind(this));
      });
    }

    /**
     * @param {Event} event
     */
    onChange(event) {
      event.stopPropagation();

      /** @type {HTMLInputElement} */
      // @ts-ignore
      const target = event.target;
      const product = JSON.parse(target.value);
      const customEvent = new CustomEvent('change', {
        detail: product,
        bubbles: true,
      });
      this.dispatchEvent(customEvent);
    }
  }

  customElements.define('ui-swatches', UISwatches);
}
